import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Button,
  Checkbox,FormControlLabel, FormGroup, TextareaAutosize} from '@mui/material';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { LoadingButton } from '@mui/lab';
import jwtAuthAxios from 'app/services/auth/jwtAuth';
import useSwalWrapper from '@jumbo/vendors/sweetalert2/hooks';
import { is } from 'date-fns/locale';
import { BACKEND_APP_URL } from 'app/utils/constants/paths';

const initialValues = {
 Stone:''
};
const PacketGenerate = () => {
const swal=useSwalWrapper()
const [loadingButon,setLoading] = useState(false)
  const handleSubmit = async(values) => {
    setLoading(true)
    if(window.confirm(`Are you sure to Print ${(values.Stone.trim().split(/\s+/)?.length)} Stones`)){
    // setLoading(false)
    await jwtAuthAxios.post('/rp/pks',{Stone:values.Stone.trim().split(/\s+/)}).then((res)=>{
      window.open(BACKEND_APP_URL+res.data)
    //   swal.fire({
    //     icon: 'success',
    //     text: 'Data inserted successfully',
    //   });
    }).catch(e => {
      swal.fire({
        icon: 'error',
        text: 'Internal server Error',
      })
      }).finally(()=>{
        setLoading(false)
      })
      // alert(12)
    }
    // console.log(values); // Do something with the form values
  };
  return (
    <>
    <Card>
      <CardHeader
          title={<Typography variant="h4">Packet Generate By Stone ID</Typography>}
          subheader={
            <Typography sx={{ mt: 1, color: 'error' }}>
              Plase Verify Detail Before Printing  The Packet 
            </Typography>
          }
        />
        <CardContent
          sx={{
            // display: 'flex',
            // minWidth: 0,
            // alignItems: 'center',
            // justifyContent: 'center',
            backgroundColor: (theme) => theme.palette.action.hover,
          }}
        >
<Formik initialValues={initialValues} style={{ width: '100%' }} onSubmit={handleSubmit}>
      {({ values,handleChange  }) => (
        <Form>
          <FormGroup>
          <Typography variant="subtitle1">Enter your Stone Id:</Typography>
      <TextareaAutosize
        rows={4} // Specify the number of rows
        onChange={handleChange}
        name='Stone'
        placeholder="Please Enter Yore Stone Ids Which You Want To Print..."
        style={{ width: '100%' ,minHeight:'150px'}} // Set the width of the textarea
      />
            {/* <FormControlLabel
              control={<Checkbox checked={values.GREEN_DISC} name="GREEN_DISC" />}
              onChange={handleChange}
              label="Adjust With Asking Disc Rate"
            />
            <FormControlLabel
              control={<Checkbox checked={values.RED_DISC} name="RED_DISC" />}
              onChange={handleChange}
              label="Adjust With Asking Disc Rate"
            /> */}
          </FormGroup>
          <LoadingButton disabled={!values.Stone} loading={loadingButon} sx={{mt:3}} type="submit" variant='contained' color='primary'>Submit</LoadingButton>
        </Form>
      )}
    </Formik>
        {/* <LoadingButton variant='contained' color='primary'>Submit</LoadingButton> */}
        </CardContent>
        </Card>
    </>)
}


PacketGenerate.Modulename = 'PacketGenerate';
export default PacketGenerate;